import { SUBDOMAINS } from './enums';
import WincJSON from '@readcloud/clouds-and-content/src/components/names/winc.name.json';
import RosebankJSON from '@readcloud/clouds-and-content/src/components/names/rosebank.name.json';

const domainsToCloudName = {
  [SUBDOMAINS.WINC]: WincJSON,
  [SUBDOMAINS.ROSEBANKSC]: RosebankJSON,
} as const;

export { domainsToCloudName };
